import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAnalytics } from 'hooks';

function Analytics(props) {
  const { landingPage, institution } = props;

  const { uid: landingPageUid, slug: landingPageSlug } = landingPage || {};
  const { uid: institutionUid, slug: institutionSlug } = institution || {};

  const { registerEvent } = useAnalytics();

  useEffect(() => {
    if (landingPageUid)
      registerEvent('landing-page-view', {
        slug: landingPageSlug,
        uid: landingPageUid,
        institution_uid: institutionUid,
        institution_slug: institutionSlug,
      });
  }, [registerEvent, landingPageUid, landingPageSlug, institutionUid, institutionSlug]);

  return null;
}

Analytics.propTypes = {
  landingPage: PropTypes.object,
  institution: PropTypes.any,
};

export default Analytics;
